import React from 'react';
import { StarIcon } from 'lucide-react';
import { socialStats, testimonios } from '../data/content';
export function SocialProof() {
  return <section aria-label="Prueba social" className="w-full border-b border-surface-line bg-surface-alt" data-id="element-156" data-mp="3lu5opipytvmz">
      <div className="mx-auto max-w-7xl px-5 py-8 sm:px-6 sm:py-12" data-id="element-157" data-mp="36xy6up2156av">
        <dl className="grid grid-cols-4 gap-2 border-b border-surface-line pb-6" data-id="element-158" data-mp="3bv6ngl7j52a0">
          {socialStats.map(stat => <div key={stat.etiqueta} className="text-center" data-id="element-159" data-mp="3h7k2yi8aemh">
              <dt className="sr-only" data-id="element-160" data-mp="8cmx5o8ew6hu">{stat.etiqueta}</dt>
              <dd data-id="element-161" data-mp="3pupjifn2gn5y">
                <span className="font-display block text-2xl leading-none text-ink-strong sm:text-4xl" data-id="element-162" data-mp="3pv7pw53g0hrl">
                  {stat.valor}
                </span>
                <span className="mt-0.5 block text-[11px] font-semibold text-ink-muted sm:text-sm" data-id="element-163" data-mp="3ur6aripkbhn9">
                  {stat.etiqueta}
                </span>
              </dd>
            </div>)}
        </dl>

        <ul className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-3 sm:gap-4" data-id="element-164" data-mp="1u9l9bktd6pdj">
          {testimonios.map(t => <li key={t.nombre} className="flex flex-col rounded-xl border border-surface-line bg-white p-4 shadow-card" data-id="element-165" data-mp="1pbjey3qhn3mr">
              <div className="flex items-center gap-0.5 text-brand" aria-label="5 de 5 estrellas" data-id="element-166" data-mp="241ha53mu4tlg">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-current" aria-hidden="true" data-id="element-167" data-mp="2819ltp7izfv1" data-mpi={i} />)}
              </div>
              <blockquote className="mt-2.5 text-[13px] leading-relaxed text-ink sm:text-sm" data-id="element-168" data-mp="2mys90n4k1l0d">
                “{t.texto}”
              </blockquote>
              <div className="mt-auto flex items-center gap-2.5 pt-4" data-id="element-169" data-mp="2hxck2jz9aucp">
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-brand-soft text-[11px] font-extrabold text-brand-dark" data-id="element-170" data-mp="slaj4tgogc26">
                  {t.iniciales}
                </span>
                <span data-id="element-171" data-mp="1db4lp7d851ti">
                  <span className="block text-[13px] font-bold text-ink-strong" data-id="element-172" data-mp="1dbmsuz1fd0g7">
                    {t.nombre}
                  </span>
                  <span className="block text-[11px] text-ink-muted" data-id="element-173" data-mp="1m9p03wbr4pbx">
                    {t.rol} · {t.pais}
                  </span>
                </span>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}